var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('auth-form',{attrs:{"action":"login"},on:{"process":function($event){_vm.login($event)}}}),(_vm.snackBar)?_c('app-snack-bar',{attrs:{"snackBar":_vm.snackBar,"text":_vm.message,"timeout":_vm.timeout}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }